import { lazy } from 'react'

import { RouteConfig } from 'packages/route'

/**
 * 路由定义
 *
 * @returns 路由定义
 */
export const getRoutes: () => RouteConfig[] = () => [
  {
    path: 'admin/systemSetting',
    name: 'AdminSystemSetting',
    getTitle: () => '系统设置',
    component: lazy(() =>
      import('./pages/index').then((m) => ({
        default: m.SystemSetting,
      }))
    ),
    subRoutes: [
      {
        path: 'authManagement',
        getTitle: () => '权限管理',
        component: lazy(() =>
          import('./pages/AuthManagement').then((m) => ({
            default: m.AuthManagement,
          }))
        ),
      },
      {
        path: 'personalization',
        getTitle: () => '个性化',
        component: lazy(() =>
          import('./pages/Personalization').then((m) => ({
            default: m.Personalization,
          }))
        ),
      },
      {
        path: 'doubleCheck',
        getTitle: () => '双因素认证',
        component: lazy(() =>
          import('./pages/DoubleCheck').then((m) => ({
            default: m.DoubleCheck,
          }))
        ),
      },
    ],
  },
]
